import { render } from "./SpinnerCircle.vue?vue&type=template&id=294072e4&scoped=true"
import script from "./SpinnerCircle.vue?vue&type=script&lang=js"
export * from "./SpinnerCircle.vue?vue&type=script&lang=js"

import "./SpinnerCircle.vue?vue&type=style&index=0&id=294072e4&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-294072e4"]])

export default __exports__